<template>
  <div id="app" class="app">
    <router-view :key="key" />
    <el-backtop target=".app" style="    right: 80px;
    bottom: 60px;"></el-backtop>

  </div>
</template>

<script>

import HeaderCommon from './components/HeaderCommon'
  import LeftNav from './components/LeftNav'

export default {
  name: 'App',
  components:{
    HeaderCommon,
    LeftNav
  },
  computed: {
    key() {
      // 只要保证 key 唯一性就可以了，保证不同页面的 key 不相同
      // console.log(this.$route.fullPath);
      return this.$route.fullPath
    }
  },
  methods:{
    hidden() {
      this.$nextTick(() => {
        if (this.$refs.header) this.$refs.header.hidden()
      })
    },
  }
}
</script>

<style lang="less" type="text/less" rel="stylesheet/less" scoped>
#app {
  margin: 0;
}
.app{
  height: 100vh;
  overflow-x: hidden;
}
  .contentclass{
    width: calc(100% - 240px);
    margin-left: 200px;
    height: calc(100% - 70px);
    margin-top: 70px;
    min-height: calc(100vh - 70px);
    background: #f5f6fa;
    padding: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue